import React from 'react';
import { useNavigate } from 'react-router-dom';
import './UpgradeModal.css';
import { CURRENCY_CONFIG, formatPrice } from '../config/currencyConfig';

const UpgradeModal = ({ isOpen, onClose, feature, currentCount, limitCount }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleUpgrade = () => {
    onClose();
    navigate('/checkout', { state: { from: 'upgrade-modal' } });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        
        <div className="modal-header">
          <div className="modal-icon">🔒</div>
          <h2>Upgrade to Premium</h2>
        </div>

        <div className="modal-body">
          <p className="modal-message">
            You've reached the limit of <strong>{limitCount} {feature}</strong> on the Free plan.
          </p>
          
          {currentCount !== undefined && (
            <div className="usage-bar">
              <div className="usage-label">Your Usage: {currentCount} / {limitCount}</div>
              <div className="progress-bar">
                <div 
                  className="progress-fill" 
                  style={{ width: `${(currentCount / limitCount) * 100}%` }}
                ></div>
              </div>
            </div>
          )}

          <div className="premium-benefits">
            <h3>Unlock Premium Benefits:</h3>
            <ul>
              <li>✅ Unlimited practice questions (500+)</li>
              <li>✅ Access to all 5 mock tests</li>
              <li>✅ Detailed answer explanations</li>
              <li>✅ AI assistant for instant help</li>
              <li>✅ Priority support</li>
              <li>✅ Lifetime access</li>
            </ul>
          </div>

          <div className="modal-price">
            <span className="price-tag">{formatPrice(CURRENCY_CONFIG.DEFAULT_AMOUNT, CURRENCY_CONFIG.DEFAULT_CURRENCY, false)}</span>
            <span className="price-subtitle">One-time payment • Lifetime access</span>
            <span className="price-info">(or equivalent in USD, EUR, etc.)</span>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-upgrade" onClick={handleUpgrade}>
            Upgrade Now
          </button>
          <button className="btn-cancel" onClick={onClose}>
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpgradeModal;
